
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
name: "homepage",
components: {
Tabbar,
TabbarItem
},
data() {
return {

}
},
created() {

},
methods: {
}
}



// WEBPACK FOOTER //
// ./src/components/index_navigation.vue